import * as React from 'react';
import { EventFunc } from '../../types/types';
import './Button.pcss';

export const Button = (props:{onClick:EventFunc, children:any, flat?:boolean, cancel?:boolean, big?:boolean, disabled?:boolean, className?:string}) => 
  <button disabled={props.disabled} className={`btn${props.flat?' flat':''}${props.cancel?' cancel':''}${props.big?' big':''}${props.disabled?' disabled':''} ripple noselect ${props.className?props.className:''}`} onClick={props.onClick}>{props.children}</button>
;

